import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PalleteTypeService } from 'src/app/service/asn/pallet-type.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';

@Component({
    selector: 'app-delete-pallet-dialog',
    templateUrl: './delete-pallet-dialog.component.html',
    styleUrls: ['./delete-pallet-dialog.component.scss'],
    standalone: false
})
export class DeletePalletDialogComponent implements OnInit {

  heading;
  description;
  successMessage
  errorMessage
  palletType
  constructor(public dialogRef: MatDialogRef<DeletePalletDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any,
    private readonly palletTypeService: PalleteTypeService, private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService,) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.description = this.dataStore.description;
  }

  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
  public saveClick() {
    this.dialogRef.close({
      event: "ConfirmEvent",

    });
  }

}
